import { Text } from "@/components/Text";
import { Card } from "@/components/ui";

export function AboutFaucet() {
  return (
    <Card>
      <Text variant="subheading">About RISE Testnet Faucet</Text>
      <ul className="text-sm space-y-1 pl-6 list-disc ">
        <li className="text-muted-foreground">
          Limited to 3 drips per token per IP per day
        </li>
        <li className="text-muted-foreground">
          Support for various tokens including ETH, WETH, USDC, and more
        </li>
        <li className="text-muted-foreground">
          Tokens are for testing purposes only and have no real value
        </li>
        <li className="text-muted-foreground">
          Use these tokens to test dApps on the RISE testnet
        </li>
      </ul>
    </Card>
  );
}
